import { inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import Parse from 'parse';

import { OrganizationsState } from '@stores/organizations';
import { Season } from '../models/season.model';

@Injectable({ providedIn: 'root' })
export class SeasonsService {
  private store = inject(Store);

  private get orgId(): string {
    return this.store.selectSnapshot(OrganizationsState.getCurrentOrganization)?.id ?? '';
  }

  getSeasons(): Observable<Season[]> {
    return from(
      Parse.Cloud.run('getSeasons', { orgId: this.orgId }).then((results: any[]) =>
        results.map((s) => ({
          ...s,
          startDate: new Date(s.startDate),
          endDate: s.endDate ? new Date(s.endDate) : null,
        }))
      )
    );
  }

  saveSeason(data: {
    seasonId?: string;
    name: string;
    startDate: Date;
    endDate?: Date | null;
    ratingInit: string;
    softResetFactor?: number;
  }): Observable<any> {
    return from(
      Parse.Cloud.run('saveSeason', {
        orgId: this.orgId,
        ...data,
        startDate: data.startDate.toISOString(),
        endDate: data.endDate ? data.endDate.toISOString() : undefined,
      })
    );
  }

  endSeason(seasonId: string, endDate?: Date): Observable<any> {
    return from(
      Parse.Cloud.run('endSeason', {
        orgId: this.orgId,
        seasonId,
        endDate: endDate ? endDate.toISOString() : undefined,
      })
    );
  }

  deleteSeason(seasonId: string): Observable<any> {
    return from(Parse.Cloud.run('deleteSeason', { orgId: this.orgId, seasonId }));
  }

  countMatchesInRange(startDate: Date, endDate?: Date | null): Observable<{ count: number }> {
    return from(
      Parse.Cloud.run('countMatchesInRange', {
        orgId: this.orgId,
        startDate: startDate.toISOString(),
        endDate: endDate ? endDate.toISOString() : undefined,
      })
    );
  }
}
